// サイト全体で共有する店舗情報・外部リンクの定数。
// FooterのNAP表記とSEOコンポーネントのJSON-LDは必ずここを参照し、二重管理を避けること。
export const INSTAGRAM_URL =
  "https://www.instagram.com/color_of_magician.bh/?hl=ja"

export const BIGHEAD_URL = "https://bighead-world.com"

export const SHOP = {
  name: "美容室BIGHEAD",
  brand: "カラーの魔術師",
  postalCode: "355-0032",
  addressRegion: "埼玉県",
  addressLocality: "東松山市",
  streetAddress: "新宿町24-16",
  telephone: "0493-24-5067",
  internationalTelephone: "+81-493-24-5067",
  openingHours: "10:00~19:00",
  opens: "10:00",
  closes: "19:00",
  closedDays: "火曜/第３水曜",
  reservationNote: "ご予約優先/飛び込みOK！",
}
